import { Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import { ReactNode } from "react";

function InfoMessage({
  children,
  tooltipMsg,
}: {
  children?: ReactNode;
  tooltipMsg?: string;
}) {
  return (
    <>
      <Typography fontStyle="italic" variant="body2">
        {children}
      </Typography>
      {tooltipMsg ? (
        <Tooltip
          arrow
          placement="top"
          sx={{ fontSize: 19, marginLeft: 1 }}
          title={tooltipMsg}
        >
          <InfoIcon />
        </Tooltip>
      ) : null}
    </>
  );
}

export default InfoMessage;
